import { useState, useEffect } from "react";
import DOMPurify from "dompurify";
import Header from "./components/Header";
import Button from "./components/Button";
import UserMenu from "./components/UserMenu";
import "./Blog.css";

const API = '/api/blog';

export default function BlogPost({ slug, user, onGoHome, onGoBlog, onEditor, onExplore, onLogin, onNewPen, onViewPens, onSettings, onLogout }) {
  const [post,    setPost]    = useState(null);
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState('');

  useEffect(() => {
    if (!slug) return;
    setLoading(true);
    fetch(`${API}/get_post.php?slug=${slug}`)
      .then(r => r.json())
      .then(data => {
        if (data.error) setError(data.error);
        else setPost(data);
        setLoading(false);
      })
      .catch(() => { setError('Failed to load post.'); setLoading(false); });
  }, [slug]);

  const formatDate = (d) => new Date(d).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });

  return (
    <div className="blog-page">

      {/* NAVBAR */}
      <Header
        onLogoClick={onGoHome}
        navItems={[
          { label: 'Editor',     onClick: onEditor },
          { label: 'Explore',    onClick: onExplore },
          { label: 'Challenges', onClick: () => {} },
          { label: 'Blog',       onClick: onGoBlog },
        ]}
        rightExtra={
          <span className="blog-nav-link" onClick={onGoBlog}>← All Posts</span>
        }
        authSlot={
          user ? (
            <UserMenu
              user={user}
              onLogout={onLogout}
              items={[
                { label: 'New Pen',  icon: '✏️', onClick: onNewPen },
                { label: 'Home',     icon: '🏠', onClick: onGoHome },
                { label: 'My Pens',  icon: '📁', onClick: onViewPens },
                { label: 'Explore',  icon: '🔥', onClick: onExplore },
                { label: 'Settings', icon: '⚙️', onClick: onSettings },
              ]}
            />
          ) : (
            <Button variant="secondary" size="sm" onClick={onLogin}>Login</Button>
          )
        }
      />

      <div className="blogpost-container">
        {loading && <div className="blog-loading">Loading post...</div>}
        {error   && <div className="blog-error">{error}</div>}

        {!loading && post && (
          <article className="blogpost-article">
            {/* Tags */}
            {post.tags && (
              <div className="blog-card-tags" style={{marginBottom: '16px'}}>
                {post.tags.split(',').map((t, i) => (
                  <span key={i} className="blog-tag">{t.trim()}</span>
                ))}
              </div>
            )}

            {/* Title */}
            <h1 className="blogpost-title">{post.title}</h1>

            {/* Meta */}
            <div className="blogpost-meta">
              <span>📅 {formatDate(post.created_at)}</span>
              <span>👁 {post.views} views</span>
              <span>✍️ WSNCode Team</span>
            </div>

            {/* Cover Image */}
            {post.cover_image && (
              <img className="blogpost-cover" src={post.cover_image} alt={post.title} />
            )}

            {/* Content */}
            <div
              className="blogpost-content"
              dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(post.content || '') }}
            />

            {/* Back button */}
            <div className="blogpost-back">
              <Button variant="ghost" onClick={onGoBlog}>← Back to Blog</Button>
            </div>
          </article>
        )}
      </div>

      <footer className="blog-footer">
        <p>© 2026 WSNCode. All rights reserved.</p>
      </footer>
    </div>
  );
}